import {ITask} from "../../../../interfaces/ITask";
import {CronExpression} from "../../../../helpers/enums";


export const initialTaskObj: ITask = {
    name: "",
    isActive: true,
    cronExpression: CronExpression.EVERY_HOUR,
    description: "",
    params: {},
    type: null,
    nextRun: new Date()
};